import { useState } from 'react'
import { Outlet } from 'react-router'

import { cn } from '@/shared/lib/cn'

import { Header } from './Header'
import { Sidebar } from './Sidebar'

/**
 * Estructura visual de todas las pantallas autenticadas: barra lateral,
 * encabezado y el área de contenido.
 *
 * `<Outlet />` es la pieza clave de React Router: es el hueco donde se dibuja
 * la página de la ruta activa. Gracias a esto la barra lateral NO se vuelve a
 * montar al navegar — solo cambia el contenido. Es lo que hace que una SPA se
 * sienta instantánea comparada con recargar la página entera.
 */
export function AppLayout() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)

  return (
    <div className="bg-background flex h-screen overflow-hidden">
      {/* Barra lateral fija en escritorio */}
      <Sidebar className="hidden lg:flex" />

      {/* En móvil se muestra como panel deslizante sobre el contenido */}
      {isMobileMenuOpen && (
        <div className="fixed inset-0 z-50 lg:hidden">
          <button
            type="button"
            className="absolute inset-0 bg-black/50"
            onClick={() => setIsMobileMenuOpen(false)}
            aria-label="Cerrar menú"
          />
          <Sidebar className="relative z-10" />
        </div>
      )}

      <div className="flex min-w-0 flex-1 flex-col">
        <Header onOpenMenu={() => setIsMobileMenuOpen(true)} />

        {/* `<main>` marca el contenido principal: permite a los lectores de
            pantalla saltarse la navegación repetida en cada página. */}
        <main className={cn('bg-background flex-1 overflow-y-auto', 'p-4 sm:p-6 lg:p-8')}>
          <div className="mx-auto max-w-7xl">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  )
}
